export var SelectCssClass;
(function (SelectCssClass) {
    SelectCssClass["Base"] = "iress-select";
    SelectCssClass["Required"] = "iress-select--required";
    SelectCssClass["Label"] = "iress-select__label";
    SelectCssClass["Select"] = "iress-select__select";
    SelectCssClass["Option"] = "iress-select__option";
    SelectCssClass["Placeholder"] = "iress-select__placeholder";
    SelectCssClass["Wrapper"] = "iress-select__wrapper";
    SelectCssClass["HiddenLabel"] = "iress-select--hidden-label";
    SelectCssClass["Focus"] = "iress-select--focus";
    SelectCssClass["Width2"] = "iress-select--width-2";
    SelectCssClass["Width4"] = "iress-select--width-4";
    SelectCssClass["Width6"] = "iress-select--width-6";
    SelectCssClass["Width8"] = "iress-select--width-8";
    SelectCssClass["Width10"] = "iress-select--width-10";
    SelectCssClass["Width12"] = "iress-select--width-12";
    SelectCssClass["Width16"] = "iress-select--width-16";
    SelectCssClass["Width25Perc"] = "iress-select--width-25-perc";
    SelectCssClass["Width50Perc"] = "iress-select--width-50-perc";
    SelectCssClass["Width75Perc"] = "iress-select--width-75-perc";
    SelectCssClass["IgnoreStack"] = "iress-stack--ignore";
})(SelectCssClass || (SelectCssClass = {}));
export var SelectVRTState;
(function (SelectVRTState) {
    SelectVRTState["Focus"] = "focus";
})(SelectVRTState || (SelectVRTState = {}));
export var SelectWidth;
(function (SelectWidth) {
    SelectWidth["Two"] = "2";
    SelectWidth["Four"] = "4";
    SelectWidth["Six"] = "6";
    SelectWidth["Eight"] = "8";
    SelectWidth["Ten"] = "10";
    SelectWidth["Twelve"] = "12";
    SelectWidth["Sixteen"] = "16";
    SelectWidth["TwentyFivePercent"] = "25Perc";
    SelectWidth["FiftyPercent"] = "50Perc";
    SelectWidth["SeventyFivePercent"] = "75Perc";
})(SelectWidth || (SelectWidth = {}));
//# sourceMappingURL=select.types.js.map